import { AgsRoleToDmsProcessMap, Prisma } from '@prisma/client';
import { useMutation, useQuery, useQueryClient, UseQueryOptions } from '@tanstack/react-query';

import { CreateAgsRoleToDmsProcessMapDto } from '@app/domain-maps-interfaces';
import { CommonFindResult } from '@app/infra-interfaces';
import { Axios } from '@app/web-components';

export const agsRoleProcessMapKeys = {
  all: ['agsRole-process'] as const,
  lists: () => [...agsRoleProcessMapKeys.all, 'list'] as const,
  list: (filters: object) => [...agsRoleProcessMapKeys.lists(), filters] as const,
  items: () => [...agsRoleProcessMapKeys.all, 'item'] as const,
  item: (id: number | object) => [...agsRoleProcessMapKeys.items(), id] as const,
};

const URL = 'ags-role-to-dms-process-map';

export const useFindManyAgsRoleToProcessMap = <T>(
  args: Prisma.AgsRoleToDmsProcessMapFindManyArgs,
  options?: Omit<UseQueryOptions<CommonFindResult<T>>, 'queryKey' | 'queryFn'>,
) => {
  const axios = Axios.useAxiosApi();

  return useQuery<CommonFindResult<T>>({
    ...options,
    queryKey: agsRoleProcessMapKeys.list(args),
    queryFn: async () => {
      const { data } = await axios.post(`/${URL}/find`, args);
      return data;
    },
  });
};

export const useCreateAgsRoleToProcessMap = () => {
  const axios = Axios.useAxiosApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateAgsRoleToDmsProcessMapDto) => axios.post<AgsRoleToDmsProcessMap>(`/${URL}`, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: agsRoleProcessMapKeys.lists() });
    },
  });
};

export const useDeleteAgsRoleToProcessMap = () => {
  const axios = Axios.useAxiosApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => axios.delete<AgsRoleToDmsProcessMap>(`/${URL}/${id}`),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: agsRoleProcessMapKeys.lists() });
      queryClient.invalidateQueries({ queryKey: agsRoleProcessMapKeys.item(data.data.id) });
    },
  });
};
